import type { SuggesterSlot } from '@metro/suggester'

/**
 * Inputs to the §13 map-tap dismissal decision.
 */
export interface MapTapSuggesterDismissInput {
  /** The open Suggester slot, or `null` when the picker is closed. */
  readonly suggesterSlot: SuggesterSlot | null
  /**
   * Whether the host is on the expanded (tablet/desktop) side-panel
   * surface. On the compact phone surface the suggester is a full-screen
   * modal over the map and the map is not interactable behind it, so a
   * map tap can never reach this path (§13 phone N/A).
   */
  readonly isExpanded: boolean
}

/**
 * §13 (2026-06-05): when Suggester is active in the tablet/desktop side
 * panel, a tap on the map must dismiss it (station-or-empty is decided by
 * the existing `MapTapped` reducer; this predicate only answers whether
 * the same tap also closes the open suggester).
 *
 * Pure so the canvas tap handler — which lives inside the v8-ignored
 * WebGL/rAF body and is exercised only by Playwright — can delegate the
 * decision to a unit-tested function instead of inlining the condition.
 */
export function shouldDismissSuggesterOnMapTap(input: MapTapSuggesterDismissInput): boolean {
  return input.isExpanded && input.suggesterSlot !== null
}
